import { render } from "./ProxyPlay.vue?vue&type=template&id=cdee944c&scoped=true"
import script from "./ProxyPlay.vue?vue&type=script&lang=js"
export * from "./ProxyPlay.vue?vue&type=script&lang=js"

import "./ProxyPlay.vue?vue&type=style&index=0&id=cdee944c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdee944c"]])

export default __exports__